export const logs = {
  log_wire_sched: "log_wire_sched_ch",
  log_vpn_service: "log_vpn_head_ch",
};

export default logs;
